import { ReactNode } from "react";
import { AttributeType } from "@evergis/api";
import { ComparisonOperator } from "@evergis/ui";

import { AttributesUpdate } from "../../hooks/attributes/useAttributes";
import { LayerInfo } from "../../interfaces/resourceInfo";

export enum FilterConditionOperation {
  AND = "&&",
  OR = "||",
}

export interface FilterCondition<Value> {
  id?: string;
  attribute: string | null;
  type?: AttributeType;
  comparisonOperator: ComparisonOperator | null;
  value: Value | string[] | null;
}

export type FilterConditionType = FilterCondition<string | number>;

export interface FeaturesFilterConditionsProps {
  conditions: FilterConditionType[];
  clearConditions: VoidFunction;
  toggleDevMode?: VoidFunction;
  isComplex?: boolean;
  children: (condition: FilterConditionType) => ReactNode;
}

export type ConditionUpdate = AttributesUpdate<FilterConditionType>;

export type AddCondition = ConditionUpdate["addAttribute"];
export type UpdateCondition = ConditionUpdate["updateAttribute"];
export type DeleteCondition = ConditionUpdate["deleteAttribute"];
export type SetConditions = ConditionUpdate["setAttributes"];

export interface ConditionOperationUpdate {
  toggleConditionOperation: VoidFunction;
  setConditionOperation: (operation: FilterConditionOperation) => void;
}

export interface AddConditionButtonProps {
  addCondition: (condition: FilterConditionType) => void;
  disabled?: boolean;
}

export interface FilterConditionState {
  rawCondition: string;
  conditions: FilterConditionType[];
  conditionOperation: FilterConditionOperation;
  parsingError: boolean;
}

export interface FeaturesFilterConditionProps {
  layer: LayerInfo;
  condition: FilterConditionType;
  updateCondition: UpdateCondition;
  deleteCondition: DeleteCondition;
}

export interface ConditionAttributeProps {
  attribute?: string;
  changeAttribute?: (options: LayerFilterOption<string>[]) => void;
  layerName?: string;
}

export interface FilterConditionsDevModeProps {
  layerName?: string;
  tableName?: string;
  condition: string;
  setCondition: (v: string) => void;
}

export type LayerFilterOption<Value> = {
  text: string;
  value: Value;
  type?: AttributeType;
};

export type ConditionOperationTitleProps = { checked?: boolean };
